import React from 'react';
import { Input } from '@roger/ui-components';
import { useBespokeSectionContext } from './BespokeSectionContext';
import { useControlDisabled } from './ControlDisabledContext';
import { joinClasses } from './fieldClassSlots';

export interface OASISNumberRenderProps {
  value: number | '';
  onChange: (v: number | null) => void;
  label: string;
}

export interface OASISNumberProps {
  qid: string;
  className?: string;
  hideLabel?: boolean;
  innerClassName?: string;
  labelClassName?: string;
  min?: number;
  max?: number;
  inputClassName?: string;
  children?: (props: OASISNumberRenderProps) => React.ReactNode;
}

export function OASISNumber({
  qid,
  className,
  hideLabel,
  innerClassName,
  labelClassName,
  min,
  max,
  inputClassName,
  children,
}: OASISNumberProps) {
  const inheritedDisabled = useControlDisabled();
  const { answers, onAnswerChange, schemaMap } = useBespokeSectionContext();
  const question = schemaMap.get(qid);

  const raw = answers[qid];
  const value = raw == null ? '' : (Number(raw) as number);
  const onChange = (v: number | null) => onAnswerChange(qid, v);
  const label = question?.question ?? question?.description ?? qid;

  return (
    <div data-qid={qid} className={className}>
      {children ? (
        children({ value, onChange, label })
      ) : (
        <div className={innerClassName ?? 'space-y-2'}>
          {!hideLabel && (
            <label
              className={joinClasses(
                'block text-sm font-semibold text-foreground',
                labelClassName
              )}
            >
              {label}
            </label>
          )}
          <Input
            type='number'
            disabled={inheritedDisabled}
            value={value}
            min={min}
            max={max}
            onChange={e => {
              const n = parseFloat(e.target.value);
              onChange(isNaN(n) ? null : n);
            }}
            className={inputClassName}
          />
        </div>
      )}
    </div>
  );
}
